module.exports = __webpack_public_path__ + "img/dbyloi-mobile-logo.c5db9c7e.svg";